export default {"src":"/login-app/[GIT_HASH]/_next/static/media/new_in_branch.91093fc9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};